export const WELCOME_FLOW_KEY = "platform-redesign-2026-09";

// The project dashboard tour is a second, independent flow — its own row per (user, flowKey), so a
// user who has seen the platform tour still gets this one on their first project dashboard visit.
export const PROJECT_WELCOME_FLOW_KEY = "project-dashboard-2026-09";

// A third, independent flow — its own row per (user, flowKey), for the first Library visit.
export const LIBRARY_WELCOME_FLOW_KEY = "library-2026-09";

// A fourth, independent flow — its own row per (user, flowKey), for the first 3D viewer visit. The
// same deck also runs on demand from the sidebar's info button (never through this key at all).
export const VIEWER_WELCOME_FLOW_KEY = "viewer-2026-09";

// The fifth and sixth flows, one per Materials page state. Mutually exclusive on any given visit
// (the trigger picks one by the inventory's current length) but each keeps its own row: a user could
// in principle see the create deck once, then not return until long after the map deck also ran.
export const MATERIALS_CREATE_FLOW_KEY = "materials-create-2026-09";
export const MATERIALS_MAP_FLOW_KEY = "materials-map-2026-09";

// The release instant. Everyone created before it sees the "existing" walkthrough; everyone created
// at or after it sees the "new" welcome. Shared by both flows above — a Frontegg account only has
// one createdAt. Set at release (RTLCA-5748) and never changed afterwards: there is no rolling back
// a release, and moving it would re-sort users who have already been shown one of the two.
export const WELCOME_RELEASE_DATE = new Date("2026-09-10T00:00:00Z");
